import pb from './pocketbase.js';

export function getStoredUserRole() {
  try {
    const raw = localStorage.getItem('pb_user_role');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Rol operativo de mesa (antes “Picker”). Acepta “Mesa” o legado “Picker”. */
export function isPickerRole(role) {
  return Boolean(role && /mesa|picker/i.test(role.descrip || ''));
}

export function isMesaRole(role) {
  return isPickerRole(role);
}

export function isAdminRole(role) {
  return Boolean(role && role.descrip === 'Administrador');
}

export function getHomeRouteForRole(role) {
  return isPickerRole(role) ? '/admin/picking' : '/admin/dashboard';
}

export function getCurrentUserId() {
  if (pb?.authStore?.model?.id) return pb.authStore.model.id;
  try {
    const raw = localStorage.getItem('pb_user');
    return raw ? JSON.parse(raw).id : null;
  } catch {
    return null;
  }
}
